import { plumberImages } from "../../../Data/Data";
import ImagePreviewGroup from "../../Common/ImagePreviewGroup";

const ComplainDetailsCard = ({ details }) => {

  console.log('complaint', details);

  const complaintImages = (details?.complaintReferenceDocuments || []).map((url, index) => ({
    id: index + 1, 
    src: url, 
    alt: `Revision Image ${index + 1}`, 
  }))

  console.log('complaint images', complaintImages);

  return (
    <div className="rounded-[0.625rem] px-4 sm:px-9 pt-3 pb-6 border border-light-blue">
      <h3 className="font-nonito_sans font-semibold text-[1.25rem] leading-[2.97rem] text-primary">
        Complaint Details
      </h3>
      <hr className="h-[0.0625rem] bg-light-blue mb-[0.625rem]" />
      <div>
        <p className="font-inter font-normal text-sm text-content">
          {details?.comments}
        </p>
        {/* Task Details */}
        <div className="mt-6">
          {/* Mobile layout */}
          <div className="flex flex-col gap-4 sm:hidden">
            <div className="flex justify-between items-center flex-wrap gap-2">
              <span className="text-[#0F161E] text-sm font-medium font-inter">
                Complaint Reason
              </span>
              <span className="text-[#4A4A4A] text-sm font-inter">
                {details?.complaintReason}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-[#0F161E] text-sm font-medium font-inter">
                Complaint Date
              </span>
              <span className="text-[#4A4A4A] text-sm font-inter">
                {details.createdAt.split('T')[0]}
              </span>
            </div>
            <div className="flex flex-col gap-3">
              <span className=" text-[#0F161E] text-sm font-medium font-inter">
                Complaint Images
              </span>
              {/* Image Preview Group */}
              <ImagePreviewGroup images={plumberImages} />
            </div>
          </div>

          {/* Desktop layout */}
          <div className="hidden sm:flex gap-[2.125rem]">
            <div className="flex flex-col gap-1">
              <span className="text-[#0F161E] text-sm font-medium font-inter">
                Complaint Reason
              </span>
              <span className="text-[#0F161E] text-sm font-medium font-inter">
                Complaint Date
              </span>
              <span className="text-[#0F161E] text-sm font-medium font-inter">
                Complaint Images
              </span>
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-[#4A4A4A] text-sm font-inter">
                {details?.complaintReason}
              </span>
              <span className="text-[#4A4A4A] text-sm font-inter">
                {details?.createdAt.split('T')[0]}
              </span>
              <div className="flex flex-col gap-1">
                <ImagePreviewGroup
                  images={complaintImages}
                  imageSize={{ width: 122, height: 101 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplainDetailsCard;
